import Icon from 'veui/components/Icon'

Icon.register({
  envelope: {
    paths: [
      {
        d: 'M4 12.64V36c0 1.1.9 2 2 2h36a2 2 0 002-2V12.64l-16.1 13.9a5.95 5.95 0 01-7.8 0L4 12.65zM40.94 10H7.06l15.66 13.52c.74.64 1.82.64 2.56 0L40.94 10zM6 6h36a6 6 0 016 6v24a6 6 0 01-6 6H6a6 6 0 01-6-6V12a6 6 0 016-6z'
      }
    ],
    width: '48',
    height: '48'
  }
})
